// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:17
import { Engagement_abstract } from './../abstract/SagaSchema/Engagement_abstract';
export class Engagement extends Engagement_abstract {}
